import { Component, Input, inject } from '@angular/core';
import { AuthService } from '../../../../core/services/auth.service';

@Component({
	selector: 'app-register-success',
	standalone: true,
	imports: [],
	templateUrl: './register_success.html',
	styleUrl: './register_success.scss'
})
export class RegisterSuccessComponent {
	@Input() email = '';
	private authService = inject(AuthService);

	goHome(): void {
		this.authService.login();
	}
}
